export const profileViewMarkup = String.raw`<!-- ====== PROFILE VIEW ====== -->
    <div class="view" id="view-profile">
      <h1 class="heading-1 mb-24">Profile</h1>

      <div class="profile-header" id="profileIdentityPanel" aria-busy="true">
        <div class="profile-header-main">
          <div class="profile-avatar" data-bind="profile.avatar">·</div>
          <div class="profile-info">
            <h2 class="profile-name-row">
              <span data-bind="profile.displayName">Loading profile…</span>
              <span class="plan-badge" data-bind="profile.planBadge" data-plan="pending">—</span>
            </h2>
            <p data-bind="profile.identity">Loading…</p>
          </div>
          <div class="profile-access-actions" id="subActions">
            <a class="profile-access-action" id="profileRedeemAction" href="/redeem" aria-label="Redeem code" data-proto-click="showRedeem()">
              <img src="/assets/icons/lucide-ticket-centered.svg" alt="" aria-hidden="true" data-icon-source="lucide">
              <span>Redeem code</span>
            </a>
            <button type="button" class="profile-access-action" id="profileUpdatePlanAction" aria-label="Update plan" data-proto-click="showPaywall()">
              <img src="/assets/icons/lucide-chevrons-up.svg" alt="" aria-hidden="true" data-icon-source="lucide">
              <span>Update plan</span>
            </button>
          </div>
          <!-- Sign in CTA — shown only to unlogged visitors, hidden by profileHydrator once auth resolves -->
          <button class="profile-signin-cta" id="profileSigninCta" style="display:none" data-proto-click="showLoginModal()">Sign in</button>
        </div>
        <div class="profile-access-summary" id="profileAccessSummary" aria-live="polite">
          <span data-bind="profile.accessSummary">Loading access…</span>
          <button type="button" class="profile-auto-renew-resume" id="profileAutoRenewResume" style="display:none">Auto-renewal off · Turn on</button>
          <span id="profileAccessSummarySuffix" style="display:none"></span>
        </div>
      </div>

      <!-- Learning stats - 6 real metrics. Row 1 (mobile 3-col grid): the three
           modality counts (read/listened/watched chapters); row 2: engagement
           aggregates. Same DOM order drives the desktop 6-column single row. -->
      <div class="profile-stats profile-stats-6">
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.articlesRead">—</div>
          <div class="stat-label">Read</div>
        </div>
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.audioListened">—</div>
          <div class="stat-label">Listened</div>
        </div>
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.videosWatched">—</div>
          <div class="stat-label">Watched</div>
        </div>
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.topicsExplored">—</div>
          <div class="stat-label">Topics explored</div>
        </div>
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.chaptersDone">—</div>
          <div class="stat-label">Chapters done</div>
        </div>
        <div class="profile-stat-card">
          <div class="stat-value" data-bind="profile.daysActive">—</div>
          <div class="stat-label">Days active</div>
        </div>
      </div>

      <!-- Invite friends entry -->
      <div class="profile-card profile-invite-card" data-proto-click="showView('referrals')" data-keyboard-action="true" role="button" tabindex="0" aria-label="Invite friends">
        <div class="profile-card-header">
          <h3>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" stroke-width="2" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 11h-6"></path><path d="M19 8v6"></path></svg>
            Invite friends<span class="av-invite-gift-wrap" aria-hidden="true" data-icon-source="lucide"><img class="av-invite-gift" src="/assets/icons/lucide-gift.svg" alt=""></span>
          </h3>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--fg-tertiary)" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </div>
        <p class="profile-invite-subtitle">Earn AI Create credits together</p>
      </div>

      <!-- History -->
      <div class="profile-card">
        <div class="profile-card-header">
          <h3>History</h3>
          <a href="#" data-proto-click="showHistoryFrom('profile')" style="font-size:14px;color:var(--accent);">See all</a>
        </div>
        <div class="profile-card-body" data-bind="profile.history">
          <!-- listening history hydrated from /api/account/dashboard -->
        </div>
      </div>

      <!-- Preferences -->
      <div class="profile-card">
        <div class="profile-card-header">
          <h3>Categories</h3>
        </div>
        <div class="profile-card-body">
          <div style="padding:16px 20px;">
            <div data-bind="profile.interests" data-cat-source="topics" style="display:flex;gap:8px;flex-wrap:wrap;"></div>
            <p style="font-size:12px;color:var(--fg-tertiary);margin-top:10px;">Tap any area to jump into Browse.</p>
          </div>
        </div>
      </div>

      <!-- Settings -->
      <div class="profile-card" id="profileSettingsCard">
        <div class="profile-card-header">
          <h3>Settings</h3>
        </div>
        <div class="profile-card-body">
          <div class="profile-settings-group-label">Account &amp; billing</div>
          <div class="profile-card-item profile-password-row" id="profilePasswordRow" hidden>
            <div class="item-left">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="10" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
              <div><span class="item-label">Password</span></div>
            </div>
            <button class="btn btn-outline" id="profilePasswordAction" data-proto-click="handleProfilePasswordAction()">Change password</button>
          </div>
          <div class="profile-card-item" id="profileMembershipBillingRow" data-proto-click="showMembershipBilling()" data-keyboard-action="true" role="button" tabindex="0" aria-label="Membership and Billing" style="cursor:pointer;">
            <div class="item-left">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="20" height="14" x="2" y="5" rx="2"></rect><line x1="2" x2="22" y1="10" y2="10"></line></svg>
              <span class="item-label">Membership &amp; Billing</span>
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="item-arrow"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
          <div class="profile-settings-group-label">Support &amp; privacy</div>
          <div class="profile-card-item" id="profileFeedbackRow" data-proto-click="showView('feedback');setActiveTab('profile')" data-keyboard-action="true" role="button" tabindex="0" aria-label="Send Feedback" style="cursor:pointer;">
            <div class="item-left">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              <span class="item-label">Send Feedback</span>
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="item-arrow"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
          <div class="profile-card-item" id="profilePrivacyRow" data-proto-click="togglePrivacyPanel()" data-keyboard-action="true" role="button" tabindex="0" aria-controls="privacyPanel" aria-expanded="false" aria-label="Privacy and Data" style="cursor:pointer;">
            <div class="item-left">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
              <span class="item-label">Privacy &amp; Data</span>
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="item-arrow"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
          <!-- Expandable privacy panel — legal links + summary (replaces the
               old standalone "Privacy & Data Controls" card). Toggled by
               togglePrivacyPanel(). Hidden by default. -->
          <div class="privacy-panel" id="privacyPanel" hidden>
            <p class="privacy-panel-summary">Review how DeepMox stores and uses your account data.</p>
            <div class="privacy-panel-links">
              <button type="button" data-proto-click="openLegalDocument('privacy')" class="privacy-panel-link">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                Privacy Policy
              </button>
              <button type="button" data-proto-click="openLegalDocument('terms')" class="privacy-panel-link">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                Terms of Service
              </button>
              <button type="button" data-proto-click="openLegalDocument('security')" class="privacy-panel-link">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                Security
              </button>
              <button type="button" data-proto-click="openLegalDocument('refund-policy')" class="privacy-panel-link">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                Refund &amp; Cancellation
              </button>
            </div>
          </div>
          <div class="profile-settings-group-label">Session</div>
          <div class="profile-card-item" id="profileLogoutRow" data-proto-click="handleLogout()" data-keyboard-action="true" role="button" tabindex="0" aria-label="Sign Out" style="color:var(--error);cursor:pointer;">
            <div class="item-left">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="color:var(--error)"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
              <span class="item-label">Sign Out</span>
            </div>
          </div>
        </div>
      </div>
    </div>`;

export const changePasswordModalMarkup = String.raw`
    <div class="modal-overlay" id="changePasswordModal">
      <div class="modal modal-auth modal-auth-narrow">
        <button type="button" class="modal-close modal-close--floating" data-proto-click="closeProfilePasswordModal()" aria-label="Close change password">
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="modal-auth-header">
          <h3 class="modal-auth-title">Change password</h3>
          <p class="modal-auth-sub">Other signed-in devices will be signed out.</p>
        </div>
        <div class="modal-auth-body">
          <div class="auth-field"><label class="wizard-label">Current password</label><input class="input" type="password" id="profileCurrentPassword" autocomplete="current-password" maxlength="128"></div>
          <div class="auth-field"><label class="wizard-label">New password</label><input class="input" type="password" id="profileNewPassword" autocomplete="new-password" minlength="8" maxlength="128"></div>
          <div class="auth-field"><label class="wizard-label">Confirm new password</label><input class="input" type="password" id="profileConfirmPassword" autocomplete="new-password" minlength="8" maxlength="128"></div>
          <p id="profilePasswordFeedback" class="auth-form-alert" role="alert" aria-live="assertive" hidden></p>
          <button type="button" class="btn btn-primary btn-lg w-full auth-primary-btn" id="profilePasswordSubmit" data-proto-click="submitProfilePasswordChange()">Change password</button>
        </div>
      </div>
    </div>`;

export const profileModalsMarkup = String.raw`
    <!-- Set Password Confirm Modal (Google-only users who don't have a password yet) -->
    <div class="modal-overlay" id="setPasswordConfirmModal" hidden>
      <div class="modal modal-auth modal-auth-narrow">
        <button type="button" class="modal-close modal-close--floating" data-proto-click="closeSetPasswordConfirmModal()" aria-label="Close set password">
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="modal-auth-header">
          <h3 class="modal-auth-title">Set a password</h3>
          <p class="modal-auth-sub">We'll send a secure link to your email so you can set a password. You'll still be able to sign in with Google.</p>
        </div>
        <div class="modal-auth-body">
          <p id="setPasswordConfirmFeedback" class="auth-form-alert" role="alert" aria-live="assertive" hidden></p>
          <div id="setPasswordTurnstileContainer" class="auth-turnstile-container"></div>
          <div id="setPasswordTurnstileStatus" class="auth-turnstile-status" role="status" aria-live="polite" hidden>
            <span id="setPasswordTurnstileStatusText"></span>
            <button type="button" class="auth-turnstile-retry" data-proto-click="retryAuthTurnstile('setPassword')">Retry verification</button>
          </div>
          <button class="btn btn-primary btn-lg w-full auth-primary-btn" id="setPasswordConfirmBtn" data-proto-click="submitSetPasswordConfirm()" disabled>Send setup link</button>
        </div>
      </div>
    </div>

    `;

/** Backwards-compatible aggregate for focused profile markup tests. */
export const profileMarkup = profileViewMarkup + profileModalsMarkup;

export const cancelAutoRenewModalMarkup = String.raw`<!-- Cancel Auto-Renew Confirmation Modal -->
    <div class="modal-overlay" id="cancelAutoRenewModal" hidden>
      <div class="modal modal--md">
        <div class="modal-header">
          <div class="modal-heading">
            <h3 class="modal-title">Cancel Auto-Renew</h3>
            <p class="modal-description">Are you sure you want to cancel automatic renewal?</p>
          </div>
          <button type="button" class="modal-close" data-proto-click="closeCancelAutoRenewModal()" aria-label="Close cancel auto-renew dialog">
            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-notice modal-notice--warning">
            <p style="margin:0;">
              <strong>Warning:</strong> Your subscription will remain active until the end of the current billing period, but will not renew automatically.
            </p>
          </div>
          <p class="modal-copy" style="margin-bottom:20px;">
            To prevent accidental cancellations, please complete the verification below.
          </p>
		  <p id="cancelAutoRenewFeedback" class="operation-feedback" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
          <!-- Turnstile verification container -->
          <div id="cancelAutoRenewTurnstileContainer" style="margin-bottom:20px;min-height:0;text-align:center;"></div>
		  <div class="modal-actions modal-actions--split">
			<button class="btn btn-outline btn-lg" data-proto-click="closeCancelAutoRenewModal()">
			  Keep Auto-Renew
			</button>
			<button class="btn btn-danger btn-lg" id="confirmCancelAutoRenewBtn" data-proto-click="confirmCancelAutoRenew()" data-transient-action data-idle-label="Confirm Cancel" disabled>
			  Confirm Cancel
			</button>
          </div>
        </div>
      </div>
    </div>

    `;

export const upgradeResumeModalMarkup = String.raw`<!-- Upgrade Resume Modal (auto-renew off blocks upgrade) -->
    <div class="modal-overlay modal-overlay--protected" id="upgradeResumeModal" hidden>
      <div class="modal modal--md">
        <div class="modal-header">
          <div class="modal-heading">
            <h3 class="modal-title">Resume Auto-Renew to Upgrade</h3>
            <p class="modal-description">Upgrade to <span id="upgradeResumeTargetPlan"></span></p>
          </div>
        </div>
        <div class="modal-body">
		  <div id="upgradeResumePromptBody" data-reset-view="show">
            <p class="modal-copy" style="margin-bottom:20px;">
              Your subscription has auto-renew turned off, so an upgrade can't be processed until it's back on. No charge was made.
            </p>
            <div class="modal-actions modal-actions--split">
              <button class="btn btn-outline btn-lg" data-proto-click="closeUpgradeResumeModal()">Not now</button>
			  <button class="btn btn-primary btn-lg" id="resumeUpgradeRenewBtn" data-proto-click="resumeUpgradeRenew()" data-transient-action data-idle-label="Re-open Auto-Renew" data-idle-disabled="false">Re-open Auto-Renew</button>
            </div>
          </div>
		  <div id="upgradeResumeSupportBody" data-reset-view="hide" hidden>
            <p class="modal-copy" style="margin-bottom:20px;">
              We couldn't turn auto-renew back on. You can try upgrading again later &mdash; no charge was made. If this keeps happening, email <a href="mailto:support@deepmox.com" style="color:var(--accent);">support@deepmox.com</a> or send us feedback.
            </p>
            <div class="modal-actions modal-actions--split">
              <button class="btn btn-outline btn-lg" data-proto-click="closeUpgradeResumeModal()">Not now</button>
              <button class="btn btn-outline btn-lg" data-proto-click="openFeedbackFromUpgradeResume()">Send Feedback</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    `;

export const upgradeConfirmModalMarkup = String.raw`<!-- Upgrade Confirm Modal (paid-upgrade confirmation before charge) -->
    <div class="modal-overlay modal-overlay--protected" id="upgradeConfirmModal" hidden>
      <div class="modal modal--md">
        <div class="modal-header">
          <div class="modal-heading">
            <h3 class="modal-title">Confirm Your Upgrade</h3>
            <p class="modal-description">Upgrade to <span id="upgradeConfirmTargetPlan"></span></p>
          </div>
        </div>
        <div class="modal-body">
          <p id="upgradeConfirmBody" class="modal-copy" style="margin-bottom:20px;"></p>
		  <p id="upgradeConfirmError" data-transient-feedback hidden style="font-size:13px;color:var(--error);margin:0 0 14px;line-height:1.45;"></p>
          <div class="modal-actions modal-actions--split">
            <button class="btn btn-outline btn-lg" data-proto-click="closeUpgradeConfirmModal()">Not now</button>
			<button class="btn btn-primary btn-lg" id="confirmUpgradeBtn" data-proto-click="confirmUpgradeFromPrompt()" data-transient-action data-idle-label="Confirm &amp; Pay" data-idle-disabled="false">Confirm &amp; Pay</button>
          </div>
        </div>
      </div>
    </div>

    `;
